import React from 'react'
import { TextField, Select, MenuItem } from '@material-ui/core'
import { CUSTOM_OPERATOR } from './options'

export const ValueInput = React.memo(({ value, onChange, ...props }) => (
  <TextField
    placeholder="Value"
    value={value}
    onChange={e => onChange(e.target.value)}
    variant="outlined"
    type="number"
    {...props}
  />
))

// Extracted Operator Select sub-component
export const OperatorSelect = React.memo(
  ({ operator, operators, operatorLabels, onChange, className }) => (
    <Select value={operator} onChange={onChange}>
      {Object.values(operators).map(op => (
        <MenuItem
          disabled={op === CUSTOM_OPERATOR}
          key={op}
          value={op}
          className={className}
        >
          {operatorLabels[op]}
        </MenuItem>
      ))}
    </Select>
  ),
)
